<template>
    <v-sheet
      :color="searchColor"
      rounded
      elevation="2"
    >
      <v-col>
        <div class="px-0">
          <v-icon>search</v-icon>
          Pesquisa
        </div>
        
        <v-row class="px-4 pb-2 d-flex justify-space-between">
          <v-flex xs4 sm4 md1 class="pt-4">
            <v-autocomplete
                v-model="immobileFinalityValue"
                :items="immobileFinality"
                color="blue-grey lighten-2"
                label="Finalidade"
                placeholder="Selecione"
                item-text="name"
                item-value="id"
                hide-details
                dense
                multiple
                @change="setSearchDomain('finalidade_imovel', immobileFinalityValue)"
            >
              <v-row class="pt-1">
                <template  v-slot:selection="data">
                  {{ data.item.name }}
                </template>
              </v-row>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm12 md4 class="pt-4">
            <v-autocomplete
                v-model="immobileTypeValue"
                :items="immobileTypes"
                color="blue-grey lighten-2"
                label="Tipo do imóvel"
                item-text="name"
                item-value="id"
                multiple
                hide-details
                @input="searchInput=null"
                :search-input.sync="searchInput"
                dense
                placeholder="Selecione"
                @change="setSearchDomain('tipo_imovel', immobileTypeValue)"
            >
              <v-row class="pt-1">
                <template  v-slot:selection="data">
                  {{ data.item.name }}
                </template>
              </v-row>
            </v-autocomplete>
          </v-flex> 
          <v-flex xs12 sm12 md2 class="pt-4">
            <v-autocomplete
                v-model="immobileCityValue"
                :items="immobileCitys"
                color="blue-grey lighten-2"
                label="Cidade"
                item-text="name"
                item-value="id"
                hide-details
                dense
                placeholder="Selecione"
                multiple
                @change="setSearchDomain('cidade', immobileCityValue)"
            >
              <v-row class="pt-1">
                <template  v-slot:selection="data">
                  {{ data.item.name }}
                </template>
              </v-row>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm12 md2 class="pt-4">
            <v-autocomplete
                v-model="immobileDistrictValue"
                :items="immobileDistricts"
                color="blue-grey lighten-2"
                label="Bairro"
                hide-details
                dense
                placeholder="Selecione"
                multiple
                @change="setSearchDomain('bairro', immobileDistrictValue)"
            >
              <v-row class="pt-1">
                <template  v-slot:selection="data">
                  {{ data.item.name }}
                </template>
              </v-row>
            </v-autocomplete>
          </v-flex>
          <v-flex xs5 sm5 md1 class="pt-4">
            <v-text-field
                v-model="minValue"
                color="blue-grey lighten-2"
                label="Valor mínimo R$"
                hide-details
                dense
                placeholder="Digite"
                type="number"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs5 sm5 md1 class="pt-4">
            <v-text-field
                v-model="maxValue"
                color="blue-grey lighten-2"
                label="Valor máximo R$"
                hide-details
                dense
                placeholder="Digite"
                type="number"
            >
            </v-text-field>
          </v-flex>
        </v-row>
        <!-- <div class="d-flex justify-end">
          <v-btn
            elevation="0"
            text
            class="text-capitalize"
            :loading="loadingBtnSearch"
            @click="sendSearchToServer()"
          >
            Avançar
          </v-btn>
        </div> -->
      </v-col>
    </v-sheet>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex';
import apiState from '@/ilios.store';

export default {
  name: 'MainSearch',

  components: {

  },

  data: () => ({
    immobileFinality: [{id: 1, name: "Venda"},
                       {id: 2, name: "Locação"},
                       {id: 3, name: "Ambos"}],
    immobileFinalityValue: [],
    immobileTypes: [{id: 1, name: "Casa"}, 
                    {id: 2, name: "Kitnet"}, 
                    {id: 3, name: "Sobrado"}, 
                    {id: 4, name: "Apartamento"}, 
                    {id: 5, name: "Sobreloja"}, 
                    {id: 6, name: "Terreno"},
                    {id: 7, name: "Sala"}, 
                    {id: 8, name: "Loja"}],
    immobileTypeValue: [],
    immobileCitys: [],
    immobileCityValue: [],
    immobileDistricts: [],
    immobileDistrictValue: [],
    searchInput: null,
    minValue: null,
    maxValue: null,
    immobileSearchList: [],
    domain: [],
    loadingBtnSearch: false,
  }),

  mounted() {
    this.setImmobileCustom()
    if(this.getBuyMenuId()){
      this.clickBuyMenu()
    }
    if(this.getRentMenuId()){
      this.clickRentMenu()
    }
  },

  computed: {
    buyMenuId(){
      return this.getBuyMenuId()
    },

    rentMenuId(){
      return this.getRentMenuId()
    },

    ...mapState('Company', {
      searchColor: 'searchColor',
    }),
  },

  watch: {
    buyMenuId: function(){
      this.clickBuyMenu()
    },
    rentMenuId: function(){
      this.clickRentMenu()
    }
  },

  methods: {
    ...mapActions({
      getImmobileCustom: 'Immobile/getImmobileCustom',
      setImmobilesList: 'Immobile/getImmobilesList',
      cleanImmobileList: 'Immobile/cleanImmobileList',
    }),

    ...mapGetters({
      getBuyMenuId: 'Immobile/getBuyMenuId',
      getRentMenuId: 'Immobile/getRentMenuId',
    }),     

    setSearchDomain(key, value){
      if(typeof value[0] === 'string'){
        var newValue = []
        value.forEach(element => {
          newValue.push("'" + element + "'")
        });
        value = newValue
      }
      var newDomain = "('" + key + "', 'in', [" + value + "])"
      var findValue = this.domain.find(element => element.includes(key))
      var index = this.domain.indexOf(findValue, 0)
      if (index >= 0){
        this.domain.splice(index, 1)
        if (value.length > 0) this.domain.push(newDomain)
      }
      else{
        this.domain.push(newDomain)
      }
    },

    async sendSearchToServer(){
      if (this.domain.length > 0 || this.maxValue || this.minValue){
        this.loadingBtnSearch = true
        var newDomain = []
        this.domain.forEach(element => {
          newDomain.push(element)
        })
        newDomain.push("('publicar_imovel', '=', 1)")
        if(this.minValue) newDomain.push("'|',('valor_aluguel', '>='," + this.minValue + ")," +
                                              "('valor_c_doc', '>='," + this.minValue + ")")
        if(this.maxValue) newDomain.push("'|',('valor_aluguel', '<='," + this.maxValue + ")," +
                                              "('valor_c_doc', '<='," + this.maxValue + ")")
        await this.setImmobilesList({
          domain: "[" + newDomain + "]"
        })
        this.$emit('activeSearch')
        this.loadingBtnSearch = false
      }
    },

    async setImmobileCustom(){
      this.immobileCustomValue = await this.getImmobileCustom({
        fields: "['cidade', 'bairro']",
        domain: "[('publicar_imovel', '=', 1)]"
      })
      this.setImmobileToSearch()
    },

    setImmobileToSearch(){
      this.immobileCustomValue.forEach(element => {
        var found = null
        found = this.immobileDistricts.find(district => {district == element.bairro[0]})
        if (!found) this.immobileDistricts.push(element.bairro)
        found = this.immobileCitys.find(city => city[0] == element.cidade[0])
        if (!found) this.immobileCitys.push({id: element.cidade[0], name: element.cidade[1]})
      });
    },

    cleanSearchFields(){
      this.immobileFinalityValue = []
      this.immobileTypeValue = []
      this.immobileCityValue = []
      this.immobileDistrictValue = []
      this.minValue = null
      this.maxValue = null
      this.domain = []
    },

    async clickBuyMenu(){
      if(this.buyMenuId != null){
        this.cleanSearchFields()
        this.immobileTypeValue.push(this.buyMenuId)
        this.immobileFinalityValue.push(1)
        this.immobileFinalityValue.push(3)
        await this.setSearchDomain('tipo_imovel', this.buyMenuId.id)
        await this.setSearchDomain('finalidade_imovel', 1)
        await this.setSearchDomain('finalidade_imovel', 3)
        await this.sendSearchToServer()
      }
    },

    async clickRentMenu(){
      if(this.rentMenuId != null){
        this.cleanSearchFields()
        this.immobileTypeValue.push(this.rentMenuId)
        this.immobileFinalityValue.push(2)
        this.immobileFinalityValue.push(3)
        await this.setSearchDomain('tipo_imovel', this.rentMenuId.id)
        await this.setSearchDomain('finalidade_imovel', 2)
        await this.setSearchDomain('finalidade_imovel', 3)
        await this.sendSearchToServer()
      }
    }
  },
};
</script>